export default "__VITE_ASSET__CkRG9CBP__";